export default {
    cz: {
        product: 'Produkty',
        article: 'Články',
        rental: 'Půjčovna',
        category: 'Kategorie',
        manufacture: 'Značky',
        showAll: 'Zobrazit všechny výsledky',
    },
    sk: {
        product: 'Produkty',
        article: 'Články',
        rental: 'Požičovňa',
        category: 'Kategórie',
        manufacture: 'Značky',
        showAll: 'Zobraziť všetky výsledky',
    },
}
